import { render, staticRenderFns } from "./AppConfig.vue?vue&type=template&id=1c3a7a12&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"
import style0 from "./AppConfig.vue?vue&type=style&index=0&id=1c3a7a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a7a12",
  null
  
)

export default component.exports